module.exports = __webpack_public_path__ + "media/images/weather/20_night-e4f2a8534b2707b4ff6d6df0fb723e0b.png";